import { string, arrayOf, bool } from 'prop-types'

export default {
  location: string,
  nextShowing: string,
  times: arrayOf(string),
  layoutV2: bool
}
